import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { contact } from '../../Redux/Actions/user'
const Contact = ({ modalId = "contactModal" }) => {
    const dispatch = useDispatch()
    const { userDetails } = useSelector(state => state.student || {})
    
    const [formData, setFormData] = useState({
        email: '',
        mobile: '',
        name: '',
        reasons: [],
        remarks: ''
    })
    useEffect(() => {
        if (userDetails) {
            setFormData(prev => ({
                ...prev,
                email: userDetails.email_id || '',
                mobile: userDetails.mobile_no || '',
                name: userDetails.full_name || ''
            }))
        }
    }, [userDetails])

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target
        setFormData(prev => ({
            ...prev,
            reasons: checked 
                ? [...prev?.reasons, value]
                : prev.reasons.filter(reason => reason !== value)
        }))
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

const handleClick = async () => {
    try {
        const { reasons, ...dataToSend } = {
            ...formData,
            remarks: formData.reasons.join(', ') + ' - ' + formData.remarks
        }
        
        const response = await dispatch(contact(dataToSend)).unwrap()
        
        if (response.status) {
            setFormData(prev => ({
                ...prev,
                reasons: [],
                remarks: ''
            }))
        }
    } catch (error) {
        console.error('Error sending data:', error)
    }
}


    return (
        <div className="modal common-modal checkbox-modal fade" id={modalId} tabIndex="-1" aria-labelledby={`${modalId}Label`} aria-hidden="true">
            <div className="modal-dialog modal-lg">
                <div className="modal-content border-0">
                    <div className="modal-body text-center">
                        <button type="button" className="btn-close d-none d-lg-block" data-bs-dismiss="modal" aria-label="Close"></button>
                        <h2 className='popup-title mb-5'>Contact MasterNaukri Team</h2>
                        
                        <div className="form-group position-relative mb-3">
                            <span className="absolute-label-txt">Your Email</span>
                            <input 
                                type="text" 
                                name="email"
                                placeholder="Mention here" 
                                className="form-control bg-light"
                                value={formData.email}
                                onChange={handleInputChange}
                            />
                        </div>
                        
                        <p className="modal-para text-start pt-md-3 pb-md-2">Select your reasons to contact</p>
                        
                        <div className='custom-radio-main mb-2 mb-md-5'>
                            <label className="checkbox-container form-checkbox align-items-start mb-3">
                                <input 
                                    type="checkbox" 
                                    className="form-check-input" 
                                    value="Onboarding assistance"
                                    checked={formData.reasons.includes("Onboarding assistance")}
                                    onChange={handleCheckboxChange}
                                />
                                <span className="checkboxmark form-check-label flex-1">Onboarding assistance</span>
                            </label>
                            
                            <label className="checkbox-container form-checkbox align-items-start mb-3">
                                <input 
                                    type="checkbox" 
                                    className="form-check-input" 
                                    value="Request top pre-screened profiles"
                                    checked={formData.reasons.includes("Request top pre-screened profiles")}
                                    onChange={handleCheckboxChange}
                                />
                                <span className="checkboxmark form-check-label flex-1">Request top pre-screened profiles</span>
                            </label>
                            
                            <label className="checkbox-container form-checkbox align-items-start mb-3">
                                <input 
                                    type="checkbox" 
                                    className="form-check-input" 
                                    value="Promote job posting"
                                    checked={formData.reasons.includes("Promote job posting")}
                                    onChange={handleCheckboxChange}
                                />
                                <span className="checkboxmark form-check-label flex-1">Promote job posting</span>
                            </label>
                            
                            <label className="checkbox-container form-checkbox align-items-start mb-3">
                                <input 
                                    type="checkbox" 
                                    className="form-check-input" 
                                    value="Others"
                                    checked={formData.reasons.includes("Others")}
                                    onChange={handleCheckboxChange}
                                />
                                <span className="checkboxmark form-check-label flex-1">Others</span>
                            </label>
                        </div>
                        
                        <div className="form-group">
                            <input 
                                type="text" 
                                name="remarks"
                                placeholder="Mention here" 
                                className="form-control bg-light"
                                value={formData.remarks}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    
                    <div className='modal-footer flex-nowrap d-flex flex-row flex-md-column'>
                        <button type="button" className="default-btn blue-btn w-100 me-2 me-md-0 mb-md-3" data-bs-dismiss="modal" onClick={handleClick}>Send</button>
                        <button type="button" className="default-btn w-100 blue-border-btn bg-transparent" data-bs-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
